import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

export enum ContactStatus {
  OFFLINE, AVAILABLE, AWAY
}

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  @Input()
  uid: string;

  @Input()
  name: string;

  @Input()
  icon: string = 'person';

  @Input()
  selected: boolean;

  @Output()
  onSelected = new EventEmitter<string>();

  @Input()
  status: ContactStatus = ContactStatus.OFFLINE;

  constructor() { }

  ngOnInit(): void {
  }

  getContactStatuses() {
    return ContactStatus;
  }

}
